import React from "react";

export default function EndOfDayButton({ setItemTime, setHasFocus }) {
  function handleEndOfDayClick() {
    setHasFocus(false);
    setItemTime(null);
  }

  return (
    <button className="End-of-day-button" onMouseDown={handleEndOfDayClick}>
      End of Day
    </button>
  );
}
